import { render, staticRenderFns } from "./RiskAssessments.vue?vue&type=template&id=0b7bb323"
import script from "./RiskAssessments.vue?vue&type=script&lang=js"
export * from "./RiskAssessments.vue?vue&type=script&lang=js"
import style0 from "./RiskAssessments.vue?vue&type=style&index=0&id=0b7bb323&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports